var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAccessibleShower = function SvgAccessibilityAccessibleShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 15.951,
    height: 4.023,
    x: 2.936,
    y: 22.736,
    rx: 2.011
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M6.863 26.873v1.762a.66.66 0 0 1-.66.66h-.771a.66.66 0 0 1-.66-.66v-1.762m12.487 0v1.762a.66.66 0 0 1-.66.66h-.771a.66.66 0 0 1-.66-.66v-1.762m9.817-4.326h-1.418a.66.66 0 0 1-.66-.66v-2.375a.66.66 0 0 1 .66-.66h1.418m-9.183-1.389H5.106"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M24.997 29.267V6.484a3.63 3.63 0 0 0-3.618-3.618c-.707 0-1.4.21-1.988.602"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M17.937 1.958A5.58 5.58 0 0 1 21.459.705a5.62 5.62 0 0 1 5.605 5.606v22.964"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m16.332 3.185 1.213-1.213 1.89 1.89-1.213 1.212zm0-.003c-1.74-1.275-3.683-1.576-4.662-.597m6.98 6.98c.952-.952.761-2.788-.428-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m11.222 3.393 6.62 6.62c.1.098.261.098.361 0l.827-.827-6.98-6.98-.826.826c-.1.1-.1.26-.002.36zm3.207 3.819-1.583 1.583M11.84 9.801l-1.584 1.583m5.342-3.007-1.277 1.839m-.811 1.168-1.277 1.839m1.031-7.18L11.425 7.32m-1.169.811L8.418 9.408"
  }))));
};
export default SvgAccessibilityAccessibleShower;